import React, {useState, useEffect, useRef} from "react";
import {defineBlock,useEditor, ChildrenBlock} from "@smartfire/wordpress-react";
import Slider from "react-slick";

import "react-circular-progressbar/dist/styles.css";
import style from "./block.module.scss";
import "slick-carousel/slick/slick.css";
import { InnerBlocks } from '@wordpress/block-editor';
import {ReactComponent as ArrowButton} from "../assets/buttonArrow.svg";




function Block() {
    const sliderRef = useRef();
    const [slides,setSlides]=useState([])

    const {isEditing} = useEditor();

    useEffect(()=>{
        if(!isEditing){
        setSlides(Array.from(document.getElementsByClassName("slider-image")))
    }} ,[isEditing] )


    const settings = {
        dots: true,
        appendDots: dots => (
                    <div className={style.dots}>
                        {dots.map((dot,index)=><div onClick={()=>{sliderRef.current.slickGoTo(index);}} className={`${style.dot} ${dot.props.className==="slick-active" || 
                        (!dots.some(element=>element.props.className==="slick-active") && index === 0) ?style.selectedDot:null}`}/>)}
                    </div>),
        arrows:false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay:true,
        autoplaySpeed:6000,
        adaptiveHeight: false,
    };
   
return <div className={style.block}>
        
        <div className={style.content}>
            <div className={style.sliderContainer}>
                {isEditing ?
                <div>Ajouter des slides: 
                      <InnerBlocks allowedBlocks={["smartfire/slider-item"]}/>
                </div>:<>
                     <div className={style.arrowBlock+' '+style.left}>
                        <div className={style.previous} onClick={() => sliderRef.current && sliderRef.current.slickPrev()}><ArrowButton/></div>
                    </div>

                    <Slider ref={sliderRef} className={style.slider} {...settings}>
                        {slides.map((slide, index)=>
                            <div dangerouslySetInnerHTML={{__html: slide.outerHTML}} />
                        )}
                        
                    </Slider>
                     <div className={style.arrowBlock+' '+style.right}>
                        <div className={style.next} onClick={() => sliderRef.current && sliderRef.current.slickNext()}><ArrowButton/></div>
                    </div>

                    <div className={style.hiddenImage}>
                        <ChildrenBlock/>
                    </div>
                    </>
                }
            
            </div>
        </div>
    </div>
}

export default defineBlock({
    Block,
    setup: {
        title: "Slider",
    }
});
